import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { DataHelper } from '@helpers/data.helper';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { DecimalPipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { LocalizationService } from '@services/localization.service';
import { WebWorkerService } from '../modules/workers/web-worker.service';
import { environment } from '@environments/environment';
import { TranslatePipe } from '@pipes/translate.pipe';
import { DelayQueueExecutor } from 'rx-queue';
import { getProductName } from '../pipes/getProductName.pipe';

declare let $;

type betStopReasonEventListType = betStopReasonEventType[];

type betStopReasonEventType = {
  BetradarMatchId?: string;
  betStopReasonId?: number;
  time?: number;
  teamScore?: {
    homeTeamScore: string;
    awayTeamScore: string;
  };
  homeTeamName?: string;
  awayTeamName?: string;
};

@Component({
  selector: 'navbar',
  templateUrl: '../sharedTemplates/navbar.component.html',
})
export class NavbarComponent implements OnInit, AfterViewInit, OnDestroy {
  private oldLiveMatch: any = [];
  private oldLiveMatchCreatedDate: any = '';
  private betStopReasonEventList: betStopReasonEventListType = [];
  private betStopReasonEventExecutor = new DelayQueueExecutor(8 * 1000);
  public betStopReasonEvent: betStopReasonEventType = {};
  private betStopReasonEventListener: EventEmitter<any> = new EventEmitter();
  slideList = [];
  lastLoginDate: any;
  customerInfo: any;
  leftMenu: false;
  rightMenu: false;

  _BalanceAmount;

  isSignIn = false;

  searchState = false;
  searchFb: UntypedFormGroup;

  liveNavBarSubscription;
  liveMatchList = [];
  oldLiveMatchList = [];

  narvbarDateTimeInterval;
  narvbarDateTime = '';

  langDatas;
  langDatasArry = [];

  currentRoute = '';

  IsRegisterActive = true;
  accountTabMenu;
  constructor(
    public _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _fbuilder: UntypedFormBuilder,
    private _ApiService: ApiService,
    public _DataHelper: DataHelper,
    private _Router: Router,
    private cp: DecimalPipe,
    public _MatDialog: MatDialog,
    public _LocalizationService: LocalizationService,
    private _webWorkerService: WebWorkerService,
    private route: ActivatedRoute
  ) {
    const translator = new TranslatePipe(this._LocalizationService);

    this.IsRegisterActive = environment.IsRegisterActive;
    //
    // this.currentRoute = this._UiHelper.currentRoute;
    // this._UiHelper.currentRouteListener.subscribe((x) => this.currentRoute = x);

    this.searchFb = _fbuilder.group({
      searchInput: new UntypedFormControl({ value: '', disabled: false }),
    });

    this.setBetStopReasonLiveData();

    this.betStopReasonEventListener.subscribe((x: betStopReasonEventType) => {
      this.betStopReasonEventExecutor
        .execute(() => x)
        .then((i: betStopReasonEventType) => {
          this.betStopReasonEvent = i;
        });
      this.betStopReasonEventExecutor
        .execute(() => x)
        .then((i: betStopReasonEventType) => {
          this.betStopReasonEvent = {};
        });
    });

    this._Router.events.subscribe(routeEvent => {
      if (routeEvent instanceof NavigationEnd) {
        // B3000 Mobile için Footer
        if (this._Router.url.toString() == '/betslip' || this._Router.url.toString() == '/mybets' || this._Router.url.toString() == '/live') {
          this._UiHelper.setFooterState(false);
        } else {
          this._UiHelper.setFooterState(true);
        }
        // B3000 Mobile için Footer

        this.currentRoute = this._Router.url.toString();

        if (this.liveNavBarSubscription != undefined) {
          try {
            this.liveNavBarSubscription.unsubscribe();
          } catch (e) {
            console.log(e);
          }
        }
        if (this._Router.url.toString() == '/live') {
          //unsubscribe from live
        } else {
          this.liveNavBarSubscription = this._DataHelper.liveDataListener.subscribe(y => {
            this.liveMatchList = y;

            this.dataRebuild();
          });
        }
      }
    });

    this.langDatas = this._LocalizationService.langDatas;
    Object.keys(this.langDatas).forEach(x => {
      this.langDatasArry.push(this.langDatas[x]);
    });
  }

  setBetStopReasonLiveData() {
    const createdEventId = (event: any): string => {
      if (event?.BetradarMatchId) {
        return `${event.BetradarMatchId}-${event.HomeScore}-${event.AwayScore}`;
      }

      return '';
    };
    this._DataHelper.liveDataListener.subscribe(x => {
      if (x && x.length > 0) {
        x.forEach((i: any) => {
          if (i.SportId === 1 && this.betStopReasonEventList.filter(z => z.BetradarMatchId === createdEventId(i)).length === 0) {
            // sport => futbol
            if (this.oldLiveMatchCreatedDate !== '' && new Date().getTime() - this.oldLiveMatchCreatedDate <= 60 * 1000) {
              const oldEventData = this.oldLiveMatch.filter(z => z.BetradarMatchId === i.BetradarMatchId);
              if (oldEventData.length > 0 && (oldEventData[0].HomeScore !== i.HomeScore || oldEventData[0].AwayScore !== i.AwayScore)) {
                // önceki event ile karşılaştırma, gol gerçekten oldu ise gösterim yapıyoruz
                this.betStopReasonEventList.push({
                  BetradarMatchId: createdEventId(i),
                  betStopReasonId: oldEventData[0].HomeScore !== i.HomeScore ? 4 : 5,
                  teamScore: {
                    homeTeamScore: i.HomeScore,
                    awayTeamScore: i.AwayScore,
                  },
                  homeTeamName: i.HomeTeam,
                  awayTeamName: i.AwayTeam,
                  time: new Date().getTime(),
                });
                this.betStopReasonEventListener.emit({
                  BetradarMatchId: createdEventId(i),
                  betStopReasonId: oldEventData[0].HomeScore !== i.HomeScore ? 4 : 5,
                  teamScore: {
                    homeTeamScore: i.HomeScore,
                    awayTeamScore: i.AwayScore,
                  },
                  homeTeamName: i.HomeTeam,
                  awayTeamName: i.AwayTeam,
                  time: new Date().getTime(),
                });
              }
            }
          } else {
            if (this.betStopReasonEventList.filter(x => x.BetradarMatchId === createdEventId(i)).length > 0) {
              this.betStopReasonEventList = this.betStopReasonEventList.filter(x => x.BetradarMatchId !== createdEventId(i));
            }
          }
        });
        this.oldLiveMatch = x;
        this.oldLiveMatchCreatedDate = new Date().getTime();
      }
    });
  }

  ClearInput() {
    this.searchFb = this._fbuilder.group({
      searchInput: new UntypedFormControl({ value: '', disabled: false }),
    });
    this.searchState = false;
  }

  SearchInputSubmit() {
    //console.log('--this.searchFb--',this.searchFb.value.searchInput);

    this.searchState = false;
    if (this.searchFb.value.searchInput == '') {
      this._Router.navigate(['search', '0']);
    } else {
      this.getSearch(this.searchFb.value.searchInput);
    }
  }

  leftMenuToogler() {
    this._UiHelper.setLeftMenu();
  }

  rightMenuToogler() {
    this._UiHelper.setRightMenu();
  }

  searchFocus(e) {
    //console.log('-searchFocus-,e',e)
    if (e) {
      this.searchState = e;
      this.searchFb.getRawValue().searchInput.length > 2 ? this.getSearch(this.searchFb.getRawValue().searchInput) : null;
    } else {
      this.searchState = e;
    }
  }

  getSearch(e) {
    this.searchFb.getRawValue().searchInput.length == 0 ? this.searchFb.setValue({ searchInput: e }) : null;
    //console.log("-getSearch-",e);
    this._ApiService.getSearch(e).then(x => {
      this._DataHelper.setSearchData(x);
      this._Router.navigate(['search', e]);
    });
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params != undefined) {
        if (params.ia_affid || params.btag || params.siteid) {
          // const iacookies = JSON.parse(localStorage.getItem("IACokiees"));
          const iacookies = JSON.parse(this.getCookie('IACokiees'));

          if (iacookies == null) {
            localStorage.setItem(
              'IACokiees',
              JSON.stringify({
                ia_affid: params.ia_affid,
                btag: params.btag,
                siteid: params.siteid,
                playerid: params.playerid,
                timeStamp: new Date().getTime(),
              })
            );
            const ObjAffilation = {
              btag: params.btag,
              ia_affid: params.ia_affid,
              siteId: params.siteid,
              timeStamp: new Date().getTime(),
            };
            const ObjAffilation2 = JSON.stringify(ObjAffilation);
            this.setCookie('IACokiees', ObjAffilation2, 30);
            // this.setCookie("btag", params.btag, 30);
            // this.setCookie("ia_affid", params.ia_affid, 30);
            // this.setCookie("siteid", params.siteid, 30);
          }
        }
      }
    });
  }
  getCookie(cname) {
    const name = cname + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return null;
  }
  RunSlide() {
    for (let i = 0; i < this.slideList.length; i++) {
      setTimeout(() => {
        try {
          if (i != 0) {
            if (this.slideList != undefined && this.slideList[i - 1] != undefined) this.slideList[i - 1].visible = false;
          }
          if (this.slideList != undefined && this.slideList[i] != undefined) this.slideList[i].visible = true;
        } catch (e) {
          console.log(e);
        }
      }, i * 3000);
    }
  }

  walletSelectChange(walletItem) {
    this._UiHelper.setLoadingDialog(true);

    this._DataHelper.selectedWallet = walletItem;

    this._ApiService.switchWallet(walletItem.CustomerId, walletItem.BranchId).then(result => {
      this._ApiService
        .getClient()
        .then(result => {
          this._UiHelper.setLoadingDialog(false);
          this._UserHelper.setUser(result);
        })
        .catch();

      this._ApiService.getTaxRate().then(result => {
        this._DataHelper.setTaxRate(result);
      });
    });
  }

  ngAfterViewInit() {
    this.narvbarDateTimeInterval = setInterval(() => {
      const narvbarTime = new Date().toLocaleTimeString();
      const narvbarDate = new Date().toLocaleDateString();
      this.narvbarDateTime = narvbarDate + ' ' + narvbarTime;
    }, 1000);
    // this.getWalletList()

    // this.searchFb.valueChanges
    //   .pipe(filter((query) => query.searchInput.length > 2))
    //   .pipe(debounceTime(500))
    //   .pipe(distinctUntilChanged())
    //   .subscribe(val => {
    //     //console.log('Search ----', val);
    //     this.getSearch(val.searchInput);
    //
    //   });

    this._DataHelper.searchDataUrlListener.subscribe(x => {
      this.getSearch(x);
    });

    // Header Live Goal Slide
    this._DataHelper.liveGoalListDataListener.subscribe((x: any) => {
      // console.log('HEADER',x);
      this.slideList = x;
      if (x != []) {
        this.RunSlide();
      }
    });

    this._UserHelper.signInListener.subscribe(x => {
      if (x) {
        if (this._UserHelper.customerUser != undefined) {
          this._BalanceAmount = this._UserHelper.customerUser.BalanceAmount + ' ' + this._UserHelper.customerUser.Symbol;
        }
        this.isSignIn = this._UserHelper.isSignedIn;
        this.lastLoginDate = Number(this._UserHelper.customerUser.LastLoginDate.toString().replace(/\D/g, ''));
        this.customerInfo = this._UserHelper.customerUser;
      } else {
        this.lastLoginDate = new Date();

        this.isSignIn = this._UserHelper.isSignedIn;
        this.customerInfo = this._UserHelper.customerUser;
      }
    });
    setInterval(() => {
      if (this._UserHelper.customerUser != undefined) {
        this.getUnreadMessage();
      }
    }, 300000);
  }

  getUnreadMessage() {
    if (this._UserHelper.isSignedIn == true) {
      this._ApiService.getUnreadMessage().then(result => {
        if (result != null && result != '') {
          this._UserHelper.setMessageCount(result[0].UnreadMessageCount);
        }
      });
    }
  }

  walletCloseButton() {
    this.shopDropDownOpen();
    this.showTabsMenu(2);
  }

  dataRebuild() {
    const wwsConfig = {
      langCode: this._LocalizationService.LANGCODE,
      lml: this.liveMatchList,
      old_lml: this.oldLiveMatchList,
      mfbysk: '',
      lfi: [],
      cardList: [],
      oddtype: ['9', 9, 8],
      favorable: [],
      isLive: true,
      liveSortbyTime: false,
      liveFavoriteButtonStatus: false,
      liveFavoriteData: this._DataHelper.getLiveFavoriteTournamentData(),
    };

    if (this.liveMatchList === undefined) {
      return;
    }

    const promise = this._webWorkerService
      .run(this._DataHelper.webWorkerLiveJob, wwsConfig)
      .then(result => {
        this._DataHelper.setLiveGoalListData(result.liveGoalListData);
        this.oldLiveMatchList = this.liveMatchList;
      })
      .catch();
  }

  changeTheme() {
    this._UiHelper.navbarDarkThemeState = true;
    this._UiHelper.darkThemeListener.emit();
  }

  ngOnDestroy() {
    if (this.narvbarDateTimeInterval) {
      clearInterval(this.narvbarDateTimeInterval);
    }
  }

  langDropdownOpen() {
    // this.langDropdownIsOpen = !this.langDropdownIsOpen;
    this._UiHelper.langDropdownOpen();
  }
  loginDropDownOpen() {
    // this.loginDropDownIsOpen = !this.loginDropDownIsOpen;
    this._UiHelper.loginDropDownOpen();
  }
  openSideBar() {
    // document.getElementById("rightSidenav").style.width = "75%";
    this._UiHelper.b3000SetRightMenuState('open');
    this._UiHelper.b3000SetAcountMobileState('close');
    // console.warn("openSideBar")
  }

  changeActiveLanguage(x) {
    this._LocalizationService.changeLang(x);
  }
  shopDropDownOpen() {
    // this.shopDropDownIsOpen=!this.shopDropDownIsOpen;
    this._UiHelper.shopDropDownOpen();
  }

  showTabsMenu(e?) {
    this._UiHelper.openShowTabsMenu();
    if (e) {
      this._UiHelper.tabsTitleChange(e);
    }
  }
  closeDimmer() {
    this._UiHelper.closeDimmer();
    this._UiHelper.b3000SetLeftMenuState('close');
  }

  openLeftMenu() {
    // document.getElementById("rightSidenav").style.width = "75%";
    this._UiHelper.b3000SetLeftMenuState('open');

    this._UiHelper.leftMenuOpen();
  }

  clickOutside(event: any) {
    if (
      event &&
      event.targetElement.id != 'rightMenuUserIcon' &&
      event.targetElement.id != 'quickTippSettingsIcon' &&
      event.targetElement.id != 'quickTippLoginButton' &&
      event.clickInside == false
    )
      this._UiHelper.b3000SetRightMenuState('close');
    // if(!this._UiHelper.rightMenuState && event.clickInside == true){
    //   this._UiHelper.b3000SetRightMenuState("open");
    // }
  }

  goToSportSearch() {
    this._UiHelper.setSportInputStatus(true);

    this._Router.navigate(['search']);
  }

  OpenAccountMobile(selectMenu) {
    // this.selectMenu=selectMenu;
    this._UiHelper.b3000SetAcountMobileState('open', selectMenu);
    this._UiHelper.b3000SetRightMenuState('close');
  }

  private setCookie(name: string, value: string, expireDays: number, path = '') {
    const d: Date = new Date();
    d.setTime(d.getTime() + expireDays * 1 * 60 * 24 * 60 * 1000);
    const expires = `expires=${d.toUTCString()}`;
    const cpath = `; path=/`;
    const domain = '.bet500.bet;path=/';
    const domain2 = '.games.bet500.bet;path=/';
    const domain3 = '.bet500.bet;path=/home';
    const domain4 = '.games.bet500.bet;path=/home';

    document.cookie = `${name}=${value}; ${expires}${cpath};domain=${domain};`;
    document.cookie = `${name}=${value}; ${expires}${cpath};domain=${domain2};`;
    document.cookie = `${name}=${value}; ${expires}${cpath};domain=${domain3};`;
    document.cookie = `${name}=${value}; ${expires}${cpath};domain=${domain4};`;

    document.cookie = `${name}=${value}; ${expires}${cpath}; `;
  }
  openGameCasino() {
    const sessionid = '_' + Math.random().toString(36).substr(2, 9);
    this._ApiService.CasinoGameCreateToken(sessionid).then(result => {
      this.setCookie('gamesessionid', sessionid, 1, 'casino');

      window.open(result.url, '_blank');
    });
  }
  // private setCookie2(name: string, value: string, expireDays: number, path: string = '') {
  //   let d: Date = new Date();
  //   d.setTime(d.getTime() + expireDays * 1 * 60 * 60 * 1000);
  //   let expires: string = `expires=${d.toUTCString()}`;
  //   let cpath: string = path ? `; path=${path}` : '';
  //   document.cookie = `${name}=${value}; ${expires}${cpath}`;
  // }
}
